import type { UseQueryResult } from "@tanstack/react-query"

/**
 * `combine` for useQueries: the queries' data in query order, whether any is still
 * loading, and the first error. Plain arrays/objects only — react-query's structural
 * sharing then hands back the previous value while nothing changed (it can't see
 * through a Map), so memos built on it hold even across unrelated re-renders.
 */
export function collectQueryResults<TData>(results: UseQueryResult<TData>[]) {
  return {
    data: results.map((result) => result.data),
    isLoading: results.some((result) => result.isLoading),
    error: results.find((result) => result.error)?.error ?? null,
  }
}
